<template>
  <v-snackbar v-model="show" right top :vertical="isArray" :color="type" :timeout="timeout" @input="close">
    <v-list dark class="transparent">
      <v-list-item v-for="(text, index) in texts" :key="index" class="ma-0">
        <v-list-item-content>
          <v-list-item-title style="white-space: normal; max-height: 17em; max-width: 71%;">{{ text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-btn text @click="close">
      <v-icon left>check</v-icon>
      {{ $t("OK") }}
    </v-btn>
  </v-snackbar>
</template>
<script>
export default {
  name: "PopupMessage",
  data() {
    return {
      show: false,
      type: "info",
      texts: [],
      timeout: 5000,
      isArray: false
    }
  },
  methods: {
    popup(texts, type, timeout) {
      this.isArray = Array.isArray( texts );
      this.type  = type ? type : "info";
      this.texts = this.isArray ? texts.map(elem => elem.message) : [texts];
      this.show  = true;
      if (type === "error") {
        this.timeout = 0;
      }
      if (typeof timeout !== 'undefined') {
        this.timeout = timeout;
      }
    },

    close() {
      this.show = false;
      this.$emit("input", { type: this.type });
    }
  }
}
</script>